import React from 'react'
import { ButtonTextIcon } from 'components/Button/Button'
import IconProfileDefault from 'assets/icons/icon-profile-selected.svg'
import IconLogin from 'assets/icons/icon-signin.svg'
import { TranslateLanguage } from 'util/Translate'
import { vocabGuestRightNav } from 'util/Translate.variable'

const translate = new TranslateLanguage()
translate.addMaping(vocabGuestRightNav)

export default function GuestRightNav() {
  return (
    <div>
      <a id='login' href='/login'>
        <ButtonTextIcon type='text' text={translate.convert('เข้าสู่ระบบ')} icon={IconProfileDefault} />
      </a>
      <a id='register' href='/register'>
        <ButtonTextIcon type='text' text={translate.convert('สมัครสมาชิก')} icon={IconLogin} />
      </a>
    </div>
  )
}